import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { FileText, Calendar, IndianRupee, TrendingDown, Receipt, Download, X } from 'lucide-react';
import { Button } from './ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { useEffect, useState } from 'react';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { useDispatch, useSelector } from 'react-redux';
import { selectCompanyAddress, selectEmail, selectPrefix, selectShopDetails } from '../utility/Redux/profile';
import moment from 'moment';
import { selectUserData } from '../utility/Redux/security';
import CryptoJS from 'crypto-js';



export default function PurchaseBill() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [purchaseSummary, setPurchaseSummary] = useState([])
  const [itemList,setItemList]=useState([])
  const handleViewBill = (bill) => {
    setIsDialogOpen(true);
    getViewBillDetatils(bill.INVNO)

  };
  const dispathc = useDispatch()
  const companyDetail = useSelector(selectShopDetails)
  console.log(companyDetail)
  const getViewBillDetatils = (invno) => {
    const companYEmail = companyDetail.company_email
    const secretPass = process.env.REACT_APP_AUTH_SECRET_KEY;

    // const hmac = CryptoJS.HmacSHA256(message, secret);
    const hmac = CryptoJS.HmacSHA256(companYEmail, secretPass);
    // Convert the HMAC to a string and encode it using Base64
    const hmacString = hmac.toString(CryptoJS.enc.Base64);
    console.log('getViewBillDetatils2');
    CallAPIPromise(
      '/api/reports/viewBill',

      {
        table_prefix: prefix,
        invno: invno,
        company_email: companYEmail,
      },
      hmacString,
      dispathc
    )
      .then((response) => {
        const dataList = response.data.response;
        console.log(dataList)
        setItemList(dataList);
        // setDate(dataList[0].DATE);
        // setBillStatus(dataList[0].BILL_STATUS);
      })
      .catch((err) => {
        console.log(err);
      });
    // .finally(() => {
    //   dispatch(setloading(false));
    // });
  };
  const handleDownloadBill = (bill) => {
    // Mock download functionality
    alert(`Downloading bill #${bill.INVNO}...`);
  };

  // Purchase Bill Data with Items

  // Calculate totals
  const totalAmount = purchaseSummary.reduce((sum, bill) => sum + bill.TOTAL, 0);
  const totalDiscount = purchaseSummary.reduce((sum, bill) => sum + bill.DISQ_AMT, 0);
  const grandTotal = purchaseSummary.reduce((sum, bill) => sum +Number( bill.TOTAL), 0);
  const totalBills = purchaseSummary.length;

  // Group by date for weekly/monthly views
  const thisWeek = purchaseSummary.filter(bill => {
    const billDate = new Date(bill.DATE);
    const today = new Date('2025-11-15');
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);
    return billDate >= weekAgo && billDate <= today;
  });

  const thisMonth = purchaseSummary.filter(bill => {
    const billDate = new Date(bill.DATE);
    return billDate.getMonth() === 10; // November
  });
  const prefix = useSelector(selectPrefix)
  const shopDetails = useSelector(selectShopDetails)
  const weekTotal = thisWeek.reduce((sum, bill) => sum + Number( bill.TOTAL), 0);
  const monthTotal = thisMonth.reduce((sum, bill) => sum + Number( bill.TOTAL),0);
  useEffect(() => {
    CallAPIPromise("/api/shopPurchase/shopPurchaseSummary", {
      table_prefix: prefix,
      FDATE:moment().subtract(1,"week").format("YYYY/MM/DD"),
      TDATE:moment().format("YYYY/MM/DD"),
      ACCOUNT_NO:shopDetails?.account_no
  }).then((res) => {
    if (res?.data?.response) {
      setPurchaseSummary(res?.data?.response)
    }
   })
  }, [])
  console.log(purchaseSummary)
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-gray-900 mb-1">Purchase Bills</h2>
        <p className="text-gray-600">Track all your purchases from us</p>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card
  style={{
    background: "linear-gradient(to bottom right, #7c3aed, #4f46e5)",
    color: "white",
    border: "0",
  }}
>
  <CardHeader className={""} style={{ paddingBottom: "0.5rem" }}>
    <CardTitle
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span>Total Purchase</span>
      <IndianRupee style={{ width: "20px", height: "20px" }} />
    </CardTitle>
  </CardHeader>

  <CardContent>
    <p style={{ color: "white", marginBottom: "0.25rem" }}>
      ₹{grandTotal.toLocaleString("en-IN")}
    </p>
    <p style={{ color: "rgba(255,255,255,0.8)" }}>
      {totalBills} bills
    </p>
  </CardContent>
</Card>


        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between text-gray-900">
              <span>This Week</span>
              <Calendar className="w-5 h-5 text-blue-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-900 mb-1">₹{weekTotal.toLocaleString('en-IN')}</p>
            <p className="text-gray-600">{thisWeek.length} bills</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between text-gray-900">
              <span>This Month</span>
              <FileText className="w-5 h-5 text-green-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-900 mb-1">₹{monthTotal.toLocaleString('en-IN')}</p>
            <p className="text-gray-600">{thisMonth.length} bills</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="flex items-center justify-between text-gray-900">
              <span>Total Discount</span>
              <TrendingDown className="w-5 h-5 text-orange-600" />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-900 mb-1">₹{totalDiscount.toLocaleString('en-IN')}</p>
            <p className="text-green-600">You saved</p>
          </CardContent>
        </Card>
      </div>

      {/* Bills List */}
      <Tabs defaultValue="all" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="all">All Bills</TabsTrigger>
          <TabsTrigger value="week">This Week</TabsTrigger>
          <TabsTrigger value="month">This Month</TabsTrigger>
        </TabsList>

        <TabsContent value="all" className="mt-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-gray-900 flex items-center justify-between">
                <span>All Purchase Bills ({totalBills})</span>
                <span className="text-purple-600">₹{grandTotal.toLocaleString('en-IN')}</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {/* Desktop View */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th className="px-4 py-3 text-left text-gray-700">Invoice No</th>
                      <th className="px-4 py-3 text-left text-gray-700">Date</th>
                      <th className="px-4 py-3 text-right text-gray-700">Total</th>
                      <th className="px-4 py-3 text-right text-gray-700">Discount</th>
                      <th className="px-4 py-3 text-right text-gray-700">Grand Total</th>
                      <th className="px-4 py-3 text-center text-gray-700">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {purchaseSummary.map((bill) => (
                      <tr key={bill.INVNO} className="hover:bg-gray-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <Receipt className="w-4 h-4 text-purple-600" />
                            <span className="text-gray-900">#{bill.INVNO}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-gray-600">
                          {new Date(bill.DATE).toLocaleDateString('en-IN', { 
                            day: '2-digit', 
                            month: 'short', 
                            year: 'numeric' 
                          })}
                        </td>
                        <td className="px-4 py-3 text-right text-gray-900">
                          ₹{ Number(bill.TOTAL).toLocaleString('en-IN')}
                        </td>
                        <td className="px-4 py-3 text-right">
                          {bill.DISQ_AMT > 0 ? (
                            <span className="text-orange-600">-₹{bill.DISQ_AMT.toLocaleString('en-IN')}</span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-3 text-right">
                          <span className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <Button 
                            variant="ghost" 
                            size="sm" 
                            className="text-blue-600 hover:text-blue-700"
                            onClick={() => handleViewBill(bill)}
                          >
                            <Download className="w-4 h-4 mr-1" />
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile View */}
              <div className="md:hidden space-y-3">
                {purchaseSummary.map((bill) => (
                  <div key={bill.INVNO} className="p-4 bg-gray-50 rounded-lg space-y-3 border-2 border-gray-200">
                    {/* Header */}
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                          <Receipt className="w-5 h-5 text-purple-600" />
                        </div>
                        <div>
                          <p className="text-gray-900">Bill #{bill.INVNO}</p>
                          <p className="text-gray-600 text-xs">
                            {new Date(bill.DATE).toLocaleDateString('en-IN', { 
                              day: '2-digit', 
                              month: 'short',
                              year: 'numeric'
                            })}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-gray-600 text-xs">Grand Total</p>
                        <p className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</p>
                      </div>
                    </div>

                    {/* Details */}
                    <div className="grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Total Amount</p>
                        <p className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Discount</p>
                        {bill.DISQ_AMT > 0 ? (
                          <p className="text-orange-600">-₹{bill.DISQ_AMT.toLocaleString('en-IN')}</p>
                        ) : (
                          <p className="text-gray-400">No discount</p>
                        )}
                      </div>
                    </div>

                    {/* Action Button */}
                    <Button variant="outline" className="w-full text-blue-600 border-blue-600 hover:bg-blue-50" onClick={() => handleViewBill(bill)}>
                      <Download className="w-4 h-4 mr-2" />
                      View Bill Details
                    </Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="week" className="mt-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-gray-900 flex items-center justify-between">
                <span>This Week's Bills ({thisWeek.length})</span>
                <span className="text-blue-600">₹{weekTotal.toLocaleString('en-IN')}</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {/* Desktop View */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th className="px-4 py-3 text-left text-gray-700">Invoice No</th>
                      <th className="px-4 py-3 text-left text-gray-700">Date</th>
                      <th className="px-4 py-3 text-right text-gray-700">Total</th>
                      <th className="px-4 py-3 text-right text-gray-700">Discount</th>
                      <th className="px-4 py-3 text-right text-gray-700">Grand Total</th>
                      <th className="px-4 py-3 text-center text-gray-700">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {thisWeek.map((bill) => (
                      <tr key={bill.INVNO} className="hover:bg-gray-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <Receipt className="w-4 h-4 text-purple-600" />
                            <span className="text-gray-900">#{bill.INVNO}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-gray-600">
                          {new Date(bill.DATE).toLocaleDateString('en-IN', { 
                            day: '2-digit', 
                            month: 'short', 
                            year: 'numeric' 
                          })}
                        </td>
                        <td className="px-4 py-3 text-right text-gray-900">
                          ₹{bill.TOTAL.toLocaleString('en-IN')}
                        </td>
                        <td className="px-4 py-3 text-right">
                          {bill.DISQ_AMT > 0 ? (
                            <span className="text-orange-600">-₹{bill.DISQ_AMT.toLocaleString('en-IN')}</span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-3 text-right">
                          <span className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <Button 
                            variant="ghost" 
                            size="sm" 
                            className="text-blue-600 hover:text-blue-700"
                            onClick={() => handleViewBill(bill)}
                          >
                            <Download className="w-4 h-4 mr-1" />
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile View */}
              <div className="md:hidden space-y-3">
                {thisWeek.map((bill) => (
                  <div key={bill.INVNO} className="p-4 bg-gray-50 rounded-lg space-y-3 border-2 border-gray-200">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                          <Receipt className="w-5 h-5 text-purple-600" />
                        </div>
                        <div>
                          <p className="text-gray-900">Bill #{bill.INVNO}</p>
                          <p className="text-gray-600 text-xs">
                            {new Date(bill.DATE).toLocaleDateString('en-IN', { 
                              day: '2-digit', 
                              month: 'short',
                              year: 'numeric'
                            })}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-gray-600 text-xs">Grand Total</p>
                        <p className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Total Amount</p>
                        <p className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Discount</p>
                        {bill.DISQ_AMT > 0 ? (
                          <p className="text-orange-600">-₹{bill.DISQ_AMT.toLocaleString('en-IN')}</p>
                        ) : (
                          <p className="text-gray-400">No discount</p>
                        )}
                      </div>
                    </div>

                    <Button variant="outline" className="w-full text-blue-600 border-blue-600 hover:bg-blue-50" onClick={() => handleViewBill(bill)}>
                      <Download className="w-4 h-4 mr-2" />
                      View Bill Details
                    </Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="month" className="mt-4">
          <Card>
            <CardHeader>
              <CardTitle className="text-gray-900 flex items-center justify-between">
                <span>This Month's Bills ({thisMonth.length})</span>
                <span className="text-green-600">₹{monthTotal.toLocaleString('en-IN')}</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              {/* Desktop View */}
              <div className="hidden md:block overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th className="px-4 py-3 text-left text-gray-700">Invoice No</th>
                      <th className="px-4 py-3 text-left text-gray-700">Date</th>
                      <th className="px-4 py-3 text-right text-gray-700">Total</th>
                      <th className="px-4 py-3 text-right text-gray-700">Discount</th>
                      <th className="px-4 py-3 text-right text-gray-700">Grand Total</th>
                      <th className="px-4 py-3 text-center text-gray-700">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {thisMonth.map((bill) => (
                      <tr key={bill.INVNO} className="hover:bg-gray-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <Receipt className="w-4 h-4 text-purple-600" />
                            <span className="text-gray-900">#{bill.INVNO}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-gray-600">
                          {new Date(bill.DATE).toLocaleDateString('en-IN', { 
                            day: '2-digit', 
                            month: 'short', 
                            year: 'numeric' 
                          })}
                        </td>
                        <td className="px-4 py-3 text-right text-gray-900">
                          ₹{bill.TOTAL.toLocaleString('en-IN')}
                        </td>
                        <td className="px-4 py-3 text-right">
                          {bill.DISQ_AMT > 0 ? (
                            <span className="text-orange-600">-₹{bill.DISQ_AMT.toLocaleString('en-IN')}</span>
                          ) : (
                            <span className="text-gray-400">-</span>
                          )}
                        </td>
                        <td className="px-4 py-3 text-right">
                          <span className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <Button 
                            variant="ghost" 
                            size="sm" 
                            className="text-blue-600 hover:text-blue-700"
                            onClick={() => handleViewBill(bill)}
                          >
                            <Download className="w-4 h-4 mr-1" />
                            View
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile View */}
              <div className="md:hidden space-y-3">
                {thisMonth.map((bill) => (
                  <div key={bill.INVNO} className="p-4 bg-gray-50 rounded-lg space-y-3 border-2 border-gray-200">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                          <Receipt className="w-5 h-5 text-purple-600" />
                        </div>
                        <div>
                          <p className="text-gray-900">Bill #{bill.INVNO}</p>
                          <p className="text-gray-600 text-xs">
                            {new Date(bill.DATE).toLocaleDateString('en-IN', { 
                              day: '2-digit', 
                              month: 'short',
                              year: 'numeric'
                            })}
                          </p>
                        </div>
                      </div>
                      <div className="text-right">
                        <p className="text-gray-600 text-xs">Grand Total</p>
                        <p className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-3 pt-3 border-t border-gray-200">
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Total Amount</p>
                        <p className="text-gray-900">₹{bill.TOTAL.toLocaleString('en-IN')}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Discount</p>
                        {bill.DISQ_AMT > 0 ? (
                          <p className="text-orange-600">-₹{bill.DISQ_AMT.toLocaleString('en-IN')}</p>
                        ) : (
                          <p className="text-gray-400">No discount</p>
                        )}
                      </div>
                    </div>

                    <Button variant="outline" className="w-full text-blue-600 border-blue-600 hover:bg-blue-50" onClick={() => handleViewBill(bill)}>
                      <Download className="w-4 h-4 mr-2" />
                      View Bill Details
                    </Button>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>

      {/* Summary Stats */}
      <Card>
        <CardHeader>
          <CardTitle className="text-gray-900">Purchase Summary</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div>
              <p className="text-gray-600 mb-2">Average Bill Amount</p>
              <p className="text-gray-900 mb-1">₹{Math.round(grandTotal / totalBills).toLocaleString('en-IN')}</p>
              <div className="text-gray-600">Per bill average</div>
            </div>
            <div>
              <p className="text-gray-600 mb-2">Average Discount</p>
              <p className="text-orange-600 mb-1">₹{Math.round(totalDiscount / totalBills).toLocaleString('en-IN')}</p>
              <div className="text-gray-600">Per bill savings</div>
            </div>
          </div>

          {/* Discount Percentage */}
          <div className="mt-6 pt-6 border-t">
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray-600">Overall Discount Rate</p>
              <p className="text-orange-600">{((totalDiscount / totalAmount) * 100).toFixed(1)}%</p>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
              <div 
                className="h-full bg-orange-500 rounded-full"
                style={{ width: `${(totalDiscount / totalAmount) * 100}%` }}
              ></div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Bill Details Dialog */}
      {BillModal(isDialogOpen, setIsDialogOpen, itemList)}
    </div>
  );
}

export function BillModal(isDialogOpen, setIsDialogOpen, itemList) {
  return <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
    <DialogContent className="max-w-2xl bg-white max-h-[95vh] overflow-hidden flex flex-col p-0">
      <DialogHeader className="px-6 pt-6 pb-4 border-b sticky top-0 bg-white z-10">
        <DialogTitle className="flex items-center justify-between">
          <span>Bill Details</span>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsDialogOpen(false)}
            className="h-8 w-8"
          >
            <X className="h-4 w-4" />
          </Button>
        </DialogTitle>
      </DialogHeader>

      <div className="overflow-y-auto flex-1 px-6 pb-6">
        {itemList[0] && (
          <div className="">
            {/* Invoice Header */}
            <div
              style={{
                background: "linear-gradient(to right, #7c3aed, #4f46e5)",
                color: "white",
                padding: "1.5rem",
                borderRadius: "0.5rem",
              }}
              className='mb-2'
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  marginBottom: "1rem",
                }}
              >
                <div>
                  <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.875rem" }}>
                    Invoice Number
                  </p>
                  <p style={{ color: "white", fontSize: "1.5rem" }}>
                    #{itemList[0].INVNO}
                  </p>
                </div>

                <div style={{ textAlign: "right" }}>
                  <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.875rem" }}>
                    Invoice Date
                  </p>
                  <p style={{ color: "white" }}>
                    {new Date(itemList[0].DATE).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                </div>
              </div>

              <div
                style={{
                  borderTop: "1px solid rgba(255,255,255,0.2)",
                  paddingTop: "1rem",
                }}
              >
                <p style={{ color: "rgba(255,255,255,0.8)", marginBottom: "0.25rem" }}>
                  Total Amount
                </p>
                <p style={{ color: "white", fontSize: "2rem" }}>
                  ₹{Number(itemList[0].TOTAL).toLocaleString("en-IN")}
                </p>
              </div>
            </div>


            {/* Company Details */}
            <div className="grid grid-cols-1  ">

              <div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-gray-900">{itemList[0]?.SNAME}</p>

                </div>
              </div>
            </div>
            {/* Item Details */}
            <div>
              <p className="text-gray-900 mb-3">Item Details</p>

              {/* Desktop Table View */}
              <div className="hidden md:block border rounded-lg overflow-hidden">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-gray-700 text-sm">#</th>
                      <th className="px-4 py-3 text-left text-gray-700 text-sm">Item Name</th>
                      <th className="px-4 py-3 text-center text-gray-700 text-sm">Quantity</th>
                      <th className="px-4 py-3 text-right text-gray-700 text-sm">Price</th>
                      <th className="px-4 py-3 text-right text-gray-700 text-sm">Amount</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    {itemList.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-gray-600">{index + 1}</td>
                        <td className="px-4 py-3 text-gray-900">{item.ITEMNAME}</td>
                        <td className="px-4 py-3 text-center text-gray-900">
                          {item.QNTY} {item.UNIT}
                        </td>
                        <td className="px-4 py-3 text-right text-gray-900">
                          ₹{Number(item.SALE_PRICE).toLocaleString('en-IN')}
                        </td>
                        <td className="px-4 py-3 text-right text-gray-900">
                          ₹{Number(item.AMOUNT).toLocaleString('en-IN')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile Card View */}
              <div className="md:hidden space-y-3">
                {itemList?.map((item, index) => (
                  <div key={index} className="border rounded-lg p-3 bg-gray-50">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="w-6 h-6 bg-purple-600 text-white rounded-full flex items-center justify-center text-xs flex-shrink-0">
                        {index + 1}
                      </span>
                      <p className="text-gray-900 text-sm">{item.name}</p>
                    </div>
                    <div className="grid grid-cols-3 gap-2 pt-3 border-t">
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Quantity</p>
                        <p className="text-gray-900 text-sm">{item.QNTY} {item.UNIT}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Price</p>
                        <p className="text-gray-900 text-sm">₹{Number(item.SALE_PRICE).toLocaleString('en-IN')}</p>
                      </div>
                      <div>
                        <p className="text-gray-600 text-xs mb-1">Amount</p>
                        <p className="text-gray-900 text-sm">₹{Number(item.AMOUNT).toLocaleString('en-IN')}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Totals Section */}
              <div className="border rounded-lg overflow-hidden mt-4">
                <div className="px-4 py-3 border-b bg-gray-50">
                  <div className="flex items-center justify-between">
                    <p className="text-gray-700">Subtotal</p>
                    <p className="text-gray-900">₹{Number(itemList[0].TOTAL).toLocaleString('en-IN')}</p>
                  </div>
                </div>

                {itemList[0].DISQ_AMT > 0 && (
                  <div className="px-4 py-3 border-b bg-orange-50">
                    <div className="flex items-center justify-between">
                      <p className="text-gray-700">
                        Discount ({((itemList[0].DISQ_AMT / itemList[0].TOTAL) * 100).toFixed(1)}%)
                      </p>
                      <p className="text-orange-600">-₹{Number(itemList[0].DISQ_AMT).toLocaleString('en-IN')}</p>
                    </div>
                  </div>
                )}

                <div className="px-4 py-4 bg-purple-50">
                  <div className="flex items-center justify-between">
                    <p className="text-gray-900">Grand Total</p>
                    <p className="text-gray-900">₹{Number(itemList[0].TOTAL).toLocaleString('en-IN')}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Amount in Words */}
            <div className="bg-blue-50 p-4 rounded-lg">
              <p className="text-gray-600 mb-1 text-sm">Amount in Words</p>
              <p className="text-gray-900">
                {convertToWords(itemList[0].TOTAL)} Rupees Only
              </p>
            </div>

            {/* Payment Info */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 mb-1 text-sm">Payment Status</p>
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-green-100 text-green-700 text-sm">
                  Completed
                </span>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-600 mb-1 text-sm">Payment Mode</p>
                <p className="text-gray-900">Cash/Credit</p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t sticky bottom-0 bg-white -mx-6 px-6 pb-4">
              {/* <Button
                  onClick={() => handleDownloadBill(itemList[0])}
                  className="flex-1 bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Download PDF
                </Button> */}
              <Button
                onClick={() => setIsDialogOpen(false)}
                className="flex-1"
              >
                Close
              </Button>
            </div>

            {/* Footer Note */}
            <div className="text-center text-gray-500 text-xs pb-4 border-t pt-4">
              <p>This is a computer-generated invoice and does not require a signature.</p>
              <p className="mt-1">Thank you for your business!</p>
            </div>
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>;
}

// Helper function to convert number to words (simplified version)
function convertToWords(amount) {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

  if (amount === 0) return 'Zero';
  
  if (amount < 10) return ones[amount];
  if (amount < 20) return teens[amount - 10];
  if (amount < 100) {
    const ten = Math.floor(amount / 10);
    const one = amount % 10;
    return tens[ten] + (one ? ' ' + ones[one] : '');
  }
  if (amount < 1000) {
    const hundred = Math.floor(amount / 100);
    const rest = amount % 100;
    return ones[hundred] + ' Hundred' + (rest ? ' ' + convertToWords(rest) : '');
  }
  if (amount < 100000) {
    const thousand = Math.floor(amount / 1000);
    const rest = amount % 1000;
    return convertToWords(thousand) + ' Thousand' + (rest ? ' ' + convertToWords(rest) : '');
  }
  if (amount < 10000000) {
    const lakh = Math.floor(amount / 100000);
    const rest = amount % 100000;
    return convertToWords(lakh) + ' Lakh' + (rest ? ' ' + convertToWords(rest) : '');
  }
  
  return 'Amount too large';
}